/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/**
 * Error class for wysiwyg inline edits
 */
export class EditError extends Error {
    public static readonly Name: string = 'EditError';

    public error?: unknown;

    public required?: boolean;

    /**
     * Edit Errors
     * @param error Original Error
     */
    constructor(error: string | Error, name?: string, required?: boolean) {
        super();
        this.name = name || PROPERTY_DISABLED;
        if (error instanceof Error) {
            this.message = error.message;
            this.error = error;
        }

        this.required = required;

        // As of Typescript 2.1 if we extend the Error object the prototype must be set explicitly
        // See: https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, EditError.prototype);
    }
}

export const PROPERTY_DISABLED = '_MSDYN365_PROPERTY_DISABLED_';

export const PROPERTY_INIT = '_MSDYN365_PROPERTY_INIT_';
